module.exports = __webpack_public_path__ + "img/ship.13dca23e.jpg";